import {Box, Stack} from "@mui/material";
import {SendEmailForm} from "./SendEmailsPage.tsx";
import {Dispatch, SetStateAction, useCallback} from "react";
import {DatePicker} from "@mui/x-date-pickers";
import {JSX} from "react/jsx-runtime";

interface EmailTypeStepProps {
    control: [SendEmailForm, Dispatch<SetStateAction<SendEmailForm>>],
}

export default function DateRangeChooserStep(props: EmailTypeStepProps) {

    const [form, setForm] = props.control;

    const handleStartDateMinChanged = useCallback((date: Date | null) => {
        if (date && !isNaN(date.getTime())) {
            date.setDate(1)
            date.setHours(0, 0, 0, 0)
            setForm(
                {
                    ...form,
                    startDateMin: date,
                }
            )
        } else {
            setForm(
                {
                    ...form,
                    startDateMin: undefined,
                }
            )
        }
    }, [form])

    const handleStartDateMaxChanged = useCallback((date: Date | null) => {
        if (date && !isNaN(date.getTime())) {
            let d = new Date(date.getFullYear(), date.getMonth() + 1, 0)
            d.setHours(23, 59, 59, 0)
            setForm({
                ...form,
                startDateMax: d,
            })
        } else {
            setForm({
                ...form,
                startDateMax: undefined,
            })
        }
    }, [form])

    const handleDateModifiedMinChanged = useCallback((date: Date | null) => {
        if (date && !isNaN(date.getTime())) {
            date.setHours(0, 0, 0, 0)
            setForm({...form, dateModifiedMin: date,})
        } else {
            setForm({...form, dateModifiedMin: undefined,})
        }
    }, [form])

    let elements: JSX.Element[] = []
    if (form.type === "info") {
        elements.push(
            <DatePicker
                key={"startDateMin"}
                value={form.startDateMin || null}
                label={"Startmonat"}
                views={['month', 'year']}
                openTo="month"
                minDate={new Date(new Date().setMonth(new Date().getMonth() - 1))}
                maxDate={form.startDateMax}
                onChange={handleStartDateMinChanged}
            />,
            <DatePicker
                key={"startDateMax"}
                value={form.startDateMax || null}
                label={"Endmonat"}
                views={['month', 'year']}
                openTo="month"
                minDate={form.startDateMin}
                onChange={handleStartDateMaxChanged}
            />
        )
    } else {
        elements.push(
            <DatePicker
                key={"dateModifiedMin"}
                value={form.dateModifiedMin || null}
                label={"Änderungen seit"}
                maxDate={new Date()}
                onChange={handleDateModifiedMinChanged}
            />
        )
    }

    return (
        <>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: 2,
                }}
            >
                <Stack direction="column" spacing={4}>
                    {elements}
                </Stack>
            </Box>
        </>
    )
}